import { ChangeDetectionStrategy, Component, computed, inject, input, signal } from '@angular/core';
import { Router } from '@angular/router';
import { HierarchyService } from 'src/app/core/hierarchy.service';
import { Posizione } from '../models/posizione.model';

@Component({
  selector: 'app-position-value',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
  @if (breadcrumb()) {
  <div>
    @for (level of posizione(); track $index) {
    <a routerLink="/ricerca/{{getPosizione($index , posizione())}}" [state]="getState($index, posizione())"  [title]="level.descrizione || ''" class="posizione-link">
      {{level.sigla}}
      @if ($index < posizione().length -1) {
      <span>/</span>
      }
    </a>
    }
  </div>
  }
  @else {
  <div>
    @if (expanded()) {
    <ul>
      @for (level of posizione(); track $index) {
      <li [title]="level.descrizione || ''" class="posizione-link"  >
        @if ($index === 0) {
          <i class="fas fa-fw fa-minus-square" (click)="toggle()"></i>  <a routerLink="/ricerca/{{getPosizione($index , posizione())}}">{{level.sigla}}</a>
        }
        @else {
          <span [style.padding-left]="($index*0.4)+1.4 + 'rem'"><a routerLink="/ricerca/{{getPosizione($index , posizione())}}">{{level.sigla}}</a></span>
        }
      </li>
      }
    </ul>
    }
    @else {
      <i class="fas fa-fw" [class.fa-plus-square]="posizione().length > 1" (click)="toggle()"></i>
      <span [title]="description()" class="posizione-link"><a routerLink="/ricerca/{{getPosizione(0 , posizione())}}">{{sigla()}}</a></span>
    }
  </div>
  }
  `,
  styles: [`
    ul { padding: 0; margin: 0; list-style: none; }
    .fas { color: #237d4b; cursor: pointer; }
    .posizione-link { cursor: pointer}
    .posizione-link:hover { cursor: pointer; color:green}
  `]
})

export class PositionValueComponent {
  posizione = input.required<Posizione[]>();
  breadcrumb = input<boolean>(false);

  public description = computed(() => this.hierarchyService.getDescription(this.posizione()));
  public sigla = computed(() => this.hierarchyService.getSigla(this.posizione()));
  public expanded = signal<boolean>(false);

  private hierarchyService = inject(HierarchyService);
  private router = inject(Router);

  toggle(): void {
    this.expanded.update(current => !current);
  }

  getState(level: number, posizione: Posizione[]): { tab: number, posizione: Posizione[] } {
    let posToSearch = [...posizione];
    posToSearch = posToSearch.splice(0, level + 1);
    return { tab: 1, posizione: posToSearch };
  }

  getPosizione(level: number, posizione: Posizione[]): string {
    const re = /\//ig;
    return posizione[level].posizioneId.replace(re, '_');
  }
}
